import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import type { EmpresaDetailed } from '@/types'
import { useEmpresaContactsActions } from '@/components/Empresas/Tabs/useEmpresaContactsActions'
import { EmpresaContactEditForm } from '@/components/Empresas/Tabs/EmpresaContactEditForm'
import { EmpresaContactsList } from '@/components/Empresas/Tabs/EmpresaContactsList'

interface EmpresaContactsTabProps {
  empresa: EmpresaDetailed
  onRefresh: () => void
}

export function EmpresaContactsTab({ empresa, onRefresh }: EmpresaContactsTabProps) {
  const {
    editingContact,
    setEditingContact,
    contactEditData,
    setContactEditData,
    saving,
    syncing,
    handleSaveContact,
    handleDeleteContact,
    handleSyncAvatar,
    startEditContact,
    startNewContact,
  } = useEmpresaContactsActions(empresa.id, onRefresh)

  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <p className='text-[var(--font-color-muted)]' style={{ fontSize: 'var(--font-size-sm)' }}>
          {empresa.contatos?.length ?? 0} contato(s)
        </p>
        <Button variant='secondary' size='sm' icon={<Plus size={14} />} onClick={startNewContact}>
          Novo contato
        </Button>
      </div>

      {editingContact ? (
        <EmpresaContactEditForm
          isNew={editingContact === 'new'}
          contactEditData={contactEditData}
          setContactEditData={setContactEditData}
          saving={saving}
          syncing={syncing}
          editingContactId={editingContact}
          onCancel={() => setEditingContact(null)}
          onSave={handleSaveContact}
          onSyncAvatar={handleSyncAvatar}
        />
      ) : (
        <EmpresaContactsList
          contatos={empresa.contatos ?? []}
          onEdit={startEditContact}
          onDelete={handleDeleteContact}
        />
      )}
    </div>
  )
}
